// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';

export default class CustomerProgram {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
        this.customer = args.customer || null
        this.isMember = args.customer ? args.customer.isInCustomerProgram : false|| false
        this.programName = args.programName || ''
        this.pointsEarned = args.customer ? args.customer.bonusPointBalance : 0 || 0
        this.chain = args.chain || null
        this.chainId = args.chainId || null
        this.programDescription = args.info || ''
        this.joinDescription = args.info || ''
        this.termsOfUse = args.termsOfUse || ''
        this.customerCategories = args.customerCategories || []
        this.customerProgramId = args.customerProgramId || 0
        this.defaultCustomerCategoryId = args.defaultCustomerCategoryId || ''
        this.bonusPointValue = args.bonusPointValue || null
        this.bonusPointsDuration = args.bonusPointsDuration || null
        this.discountType = args.discountType || null
        this.productDiscountPercentage = args.productDiscountPercentage || 0
        this.treatmentDiscountPercent = args.treatmentDiscountPercent || 0
        
	}

	assign(program) {
		Object.assign(this, toCamelCaseProperties(program));
	}
}
